/**
 * The help modal's role sections, both ways (M5kdvfDr).
 *
 * Main's `GetAllHelpContent` shipped `help_role_sections` rows as
 * `{help_id, role_name, body_html}`; the store's Role-Specific tab
 * (`pickRoleSectionHtml`) and the editor's drafts (HelpModal
 * `loadDraftFromStore`) match on `role_name`. The API nests them on each
 * article as `role_sections: {role: html}`, and its write takes the same map.
 *
 * The bridge used to emit `role` instead of `role_name`, so the Role tab was
 * always empty and the editor opened every role draft blank; it then sent
 * those blank drafts back as `role_sections: []`, which the API reads as
 * "this article has no role guidance" and deleted every role section. Every
 * platform-article save by an operator wiped them.
 */

/** `GET /help-articles` rows as main's `roleSections` list. */
export function helpRoleSectionRows(articles) {
  return (articles || []).flatMap((article) => Object.entries((article && article.role_sections) || {})
    .map(([role, html]) => ({ help_id: article.help_id, role_name: role, body_html: html })));
}

/**
 * HelpModal's role sections as the API's `{role: html}` replacement map.
 *
 * A list of `{role_name, body_html}` (what the modal builds) or a map are both
 * accepted. `undefined` stays `undefined`, so the key is left out of the
 * request and the API leaves the article's role sections as they are; an
 * empty list is an empty map, which is the editor saying "no role has
 * guidance" and replaces them all.
 */
export function helpRoleSectionMap(sections) {
  if (sections === undefined || sections === null) return undefined;

  if (Array.isArray(sections)) {
    const map = {};

    sections.forEach((section) => {
      const role = String((section && (section.role_name || section.role)) || '').toLowerCase().trim();

      if (role) map[role] = (section && section.body_html) || '';
    });

    return map;
  }

  return typeof sections === 'object' ? { ...sections } : undefined;
}

export default { helpRoleSectionRows, helpRoleSectionMap };
